<template>
    <div :class="isListShow && !getScrollData ? 'listHomepageListsShow' : 'homepageList'">
       <div class="main" v-if="!isListShow">
            <ul>
                <li>
                    <router-link :to="{name: 'myNewProductList'}">
                        新品定制
                        <span></span>
                    </router-link>
                </li>
                <li >
                    <router-link :to="{name: 'myCustomizedList'}">
                        热门定制
                        <span></span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'myLogicList'}">
                        逻辑圈
                        <span></span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'myDesignShowList'}">
                        设计秀
                        <span></span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'myDesignFront'}">
                        设计前沿
                        <span></span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'myDryGoodsList'}">
                        实用干货
                        <span></span>
                    </router-link>
                </li>
            </ul>
       </div>

        <div class="main listMain" v-else>
            <ul>
                 <li :class="isShowListActive === 'inspirationList' ? 'activeClass' : ''" @click="isShowListActiveHandle('inspirationList')">
                        灵感源
                        <span class="specailSpan specailSpan-specail" v-if="isShowListActive === 'inspirationList'"></span>
                </li>
                <li :class="isShowListActive === 'productList' ? 'activeClass' : ''" @click="isShowListActiveHandle('productList')">
                        产品库
                        <span class="specailSpan" :class="imgSearchQuery ? 'specailSpan-specail' : ''"  v-if="isShowListActive === 'productList'"></span>
                </li>
                <!-- <li :class="isShowListActive === 'planList' ? 'activeClass' : ''" @click="isShowListActiveHandle('planList')">
                        场景库
                        <span class="specailSpan" :class="imgSearchQuery ? 'specailSpan-specail' : ''" v-if="isShowListActive === 'planList'"></span>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return{
                isShowListActive: 'productList',
                imgSearchQuery: this.$route.query.imgsearch,
            }
        },
        props: {
            isListShow: {
                type:Boolean,
                defaulte: false
            },
            isShowImgSearch: {
                type:Boolean,
                defaulte: true
            }
        },
        computed:{
            getScrollData() {
                return this.$store.state.app.scrollRollData;
            }
        },
        methods:{
            isShowListActiveHandle(text) {
                this.isShowListActive = text;
                if(this.imgSearchQuery && this.isShowImgSearch){
                    this.$router.replace({name:text, query:{imgsearch: 1}});
                }else{
                    if(this.GetRequest().keyword){
                        this.$router.replace({name:text,query:{keyword:this.GetRequest().keyword}});
                    }else{
                        this.$router.replace({name:text});
                    }
                }
            },
            GetRequest() {
                let url = location.search; //获取url中"?"符后的字串
                let theRequest = new Object();
                if (url.indexOf("?") != -1) {
                    var str = url.substr(1);
                    let strs = str.split("&");
                    for(var i = 0; i < strs.length; i ++) {
                        theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                    }
                }
                return theRequest;

            }
        },
        created() {
            if(document.location.href.split('/')[5] === 'product'){
                this.isShowListActive = 'productList'
            }else if(document.location.href.split('/')[5] === 'plan'){
                this.isShowListActive = 'planList'
            }else{
                this.isShowListActive = 'inspirationList'
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .homepageList, .listHomepageListsShow{
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        background: rgba(255,214,0,1);
        position: fixed;
        left: 0px;
        top:50px;
        z-index: 200;
        .main{
            margin: 0 auto;
            width: 520px;
            height: 100%;
            line-height: 50px;
            li{
                float: left;
                font-size: 14px;
                color: #6C6F70;
                height: 50px;
                width: 16.66%;
                text-align: center;
                cursor: pointer;
                position: relative;
                a{
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    &.router-link-active{
                        color: #353838;
                        span{
                            position: absolute;
                            bottom: 0;
                            left: 38%;
                            display: inline-block;
                            width: 0;
                            height: 0;
                            border-left: 10px solid transparent;
                            border-right: 10px solid transparent;
                            border-bottom: 11px solid #fff;
                            &:first-child{
                                text-align: left;
                                span{
                                    left: 20%;
                                }
                            }
                            &:last-child{
                                text-align: right;
                                span{
                                    left: 59%;
                                }
                            }
                        }
                    }
                    &:hover{
                        color: #353838;
                    }
                }
                &:hover{
                    color: #353838;
                }
                &.activeClass{
                    color: #353838;
                }
                .specailSpan{
                    position: absolute;
                    bottom: 0;
                    left: 44%;
                    display: inline-block;
                    width: 0;
                    height: 0;
                    border-left: 10px solid transparent;
                    border-right: 10px solid transparent;
                    border-bottom: 11px solid #fff;
                    &:first-child{
                        text-align: left;
                        span{
                            left: 20%;
                        }
                    }
                    &:last-child{
                        text-align: right;
                        span{
                            left: 59%;
                        }
                    }
                } /*TODO*/
                .specailSpan-specail{
                    border-bottom: 11px solid #F2F4F5;
                }
            }
            .activeLi{
                color: #353838;
            }
        }
        .listMain{
            width: 520px;
            li{
                // width: 33.33%;
                 width: 50%;
            }
        }
    }
    .listHomepageListsShow{
        position: inherit;
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        background: rgba(255,214,0,1);
        min-width: 1200px;
        li{
            span{
                position: absolute;
                bottom: 0;
                left: 44%;
                display: inline-block;
                width: 0;
                height: 0;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 11px solid #fff;
                &:first-child{
                    text-align: left;
                    span{
                        left: 20%;
                    }
                }
                &:last-child{
                    text-align: right;
                    span{
                        left: 59%;
                    }
                }
            }

            &:hover{
                color: #353838;
            }
            &.activeClass{
                color: #353838;
            }
        }
    }
</style>